export const th = {
  app: { name: 'Admin', description: 'ผู้ใช้ บทบาท สิทธิ์ และประวัติการใช้งาน' },
  nav: { users: 'ผู้ใช้', roles: 'บทบาทและสิทธิ์', permissions: 'สิทธิ์ตามแอพ', audit: 'ประวัติการใช้งาน', migrate: 'ย้ายข้อมูล' },
  migrate: {
    title: 'ย้ายข้อมูลจาก Business Zero',
    hint: 'ดึงข้อมูลหลักและยอดยกมาจาก Business Zero จับคู่ค่าและแก้รายแถวก่อนได้ แล้วนำเข้าทีละขั้นตามลำดับ',
    source: {
      title: 'แหล่งข้อมูล',
      notConnected: 'ยังไม่ได้เชื่อม Business Zero',
      notConnectedHint: 'ต้องตั้ง BUSINESS_ZERO_DATABASE_URL ของ API ด้วยบัญชีฐานข้อมูลที่อ่านได้อย่างเดียวก่อน (docs/deploy.md)',
      company: 'บริษัทใน Business Zero',
      year: 'ปีที่ยกยอด',
      pulled: 'ดึงเมื่อ {{at}} โดย {{by}}',
      pull: 'ดึงข้อมูลล่าสุด',
      pulledDone: 'ดึงข้อมูลจาก Business Zero แล้ว',
      keeps: 'ดึงใหม่ได้ทุกเมื่อ การจับคู่ค่าและการแก้รายแถวยังอยู่',
      none: 'ยังไม่ได้ดึงข้อมูล เลือกบริษัทและปี แล้วกดดึงข้อมูล',
    },
    steps: {
      title: 'ขั้นตอนนำเข้า',
      hint: 'นำเข้าตามลำดับ ขั้นหลังอ้างถึงข้อมูลของขั้นก่อนหน้า',
      rows: '{{count}} แถว',
      fix: 'ต้องแก้ {{count}}',
      check: 'ควรตรวจ {{count}}',
      edited: 'แก้แล้ว {{count}}',
      skipped: 'ไม่นำเข้า {{count}}',
      linked: 'ใช้ของเดิม {{count}}',
      import: 'นำเข้า',
      importAgain: 'นำเข้าอีกครั้ง',
      imported: 'นำเข้าแล้ว {{at}}',
      counts: 'ใหม่ {{created}} · อัปเดต {{updated}}',
      failed: 'ไม่ผ่าน {{count}} แถว',
      done: 'นำเข้าแล้ว: ใหม่ {{created}} อัปเดต {{updated}}',
      doneFailed: 'นำเข้าแล้ว: ใหม่ {{created}} อัปเดต {{updated}} ไม่ผ่าน {{failed}} แถว',
      openingFailed: 'ยกยอดไม่ได้บันทึก: ไม่ผ่าน {{failed}} แถว ต้องถูกทุกแถวจึงบันทึกได้',
      ready: 'จะนำเข้า {{count}} แถว',
      held: 'แถวที่ต้องแก้ {{count}} แถวยังไม่นำเข้า จนกว่าจะแก้หรือกดบันทึกว่าตรวจแล้ว',
      importAll: 'นำเข้าทั้งหมด',
      importAllTitle: 'นำเข้าข้อมูลหลักทั้งหมด',
      importAllBody:
        'นำเข้าขั้นที่ 1–{{last}} ตามลำดับ หยุดที่ขั้นแรกที่ยังมีแถวต้องแก้หรือไม่ผ่าน เพราะขั้นหลังอ้างถึงขั้นนั้น ยกยอดไม่รวม ให้นำเข้าทีละขั้นหลังจ่ายเงินเดือนงวดสุดท้ายใน Business Zero',
      importingAll: 'กำลังนำเข้า {{n}}/{{total}}: {{title}}',
      importAllDone: 'นำเข้าข้อมูลหลักครบ {{count}} ขั้นแล้ว ที่เหลือคือยกยอด',
      importAllStopped: 'หยุดที่ขั้น{{title}}: ต้องแก้ {{fix}} แถว ไม่ผ่าน {{failed}} แถว เปิดขั้นนั้นแก้ แล้วกดนำเข้าทั้งหมดอีกครั้ง',
      empty: 'ไม่มีแถว',
    },
    maps: {
      title: 'จับคู่ค่า',
      hint: 'ค่าใน Business Zero ตรงกับอะไรใน Thananan OS ค่าเริ่มต้นเดาตามกฎ เปลี่ยนแล้วทุกขั้นใช้ค่าใหม่ทันที',
      value: 'ใน Business Zero',
      count: 'ใช้',
      target: 'ใน Thananan OS',
      none: 'ไม่ใส่',
      guessed: 'เดาให้',
      reset: 'ใช้ที่เดาให้',
      names: {
        bank: 'ธนาคาร',
        partyType: 'ประเภทคู่ค้า',
        employeeStatus: 'สถานะพนักงาน',
        payBasis: 'การคิดค่าจ้าง',
        payMethod: 'วิธีจ่ายเงินเดือน',
        leaveType: 'ประเภทการลา',
        vehicleType: 'ประเภทรถ',
        vehicleStatus: 'สถานะรถ',
      },
    },
    totals: { title: 'ตัวเลขไว้เทียบ', hint: 'นำเข้าครบแล้วต้องได้ตามนี้' },
    left: { title: 'สิ่งที่ไม่ย้าย' },
    clear: {
      action: 'ลบข้อมูลที่ดึงมา',
      title: 'ลบข้อมูลที่ดึงมาจาก Business Zero?',
      body: 'ข้อมูลที่ดึงมา การจับคู่ค่า การแก้รายแถว และผลนำเข้าจะหายไป ส่วนข้อมูลที่นำเข้าไปแล้วยังอยู่ ทำเมื่อย้ายเสร็จแล้ว เพราะมีเงินเดือนและเลขบัญชีของทุกคน',
      done: 'ลบข้อมูลที่ดึงมาแล้ว',
    },
    step: {
      all: 'ทั้งหมด',
      fix: 'ต้องแก้',
      check: 'ควรตรวจ',
      edited: 'แก้แล้ว',
      skipped: 'ไม่นำเข้า',
      linked: 'ใช้ของเดิม',
      failed: 'นำเข้าไม่ผ่าน',
      done: 'นำเข้าแล้ว',
      notes: 'โน้ต',
      empty: 'ไม่มีแถวตามตัวกรองนี้',
    },
    row: {
      title: 'แก้แถว',
      skip: 'ไม่นำเข้าแถวนี้',
      link: 'ใช้ของที่มีอยู่แล้วแทน',
      linkHint: 'แถวนี้จะไม่ถูกสร้าง แถวอื่นที่อ้างถึงจะชี้ไปที่รายการที่เลือก',
      linkNone: 'สร้างใหม่จากแถวนี้',
      reset: 'คืนค่าจาก Business Zero',
      savedHint: 'บันทึกแล้วถือว่าตรวจแถวนี้แล้ว โน้ตของแถวจะหายไป ส่วนกฎของแต่ละช่องยังตรวจทุกครั้ง',
      failure: 'นำเข้าครั้งล่าสุดไม่ผ่าน',
      saved: 'บันทึกแถวแล้ว',
    },
  },
  access: {
    title: 'ใครทำอะไรได้',
    everything: '{{roles}} ทำได้ทุกอย่างทุกแอพ จึงไม่แสดงซ้ำในแต่ละแถว',
    only: 'เฉพาะ{{roles}}',
    everyone: 'ทุกคน',
    users: 'ผู้ใช้ที่มีสิทธิ์',
    more: 'อีก {{count}} คน',
    search: 'ค้นหาประเภทเอกสาร',
    allApps: 'ทุกแอพ',
    none: 'ไม่พบประเภทเอกสารนี้',
    hint: 'เลือกประเภทเอกสารเพื่อดูว่าแต่ละบทบาททำอะไรได้ และใครมีบทบาทนั้น',
    nobody: 'ไม่มีบทบาทใดเข้าถึง',
  },
  user: {
    title: 'ผู้ใช้',
    plural: 'ผู้ใช้',
    create: 'เพิ่มผู้ใช้',
    fields: {
      name: 'ชื่อ',
      username: 'ชื่อผู้ใช้',
      email: 'อีเมล',
      phone: 'เบอร์โทร',
      roleIds: 'บทบาท',
      branchId: 'สาขาประจำ',
      active: 'เปิดใช้งาน',
      password: 'รหัสผ่าน',
      lastLoginAt: 'เข้าใช้ล่าสุด',
    },
    sections: { main: 'ข้อมูลผู้ใช้', access: 'การเข้าใช้งาน' },
    passwordHint: 'อย่างน้อย 8 ตัวอักษร เว้นว่างไว้ถ้าไม่ต้องการเปลี่ยน',
    actions: {
      resetPassword: 'ตั้งรหัสผ่านใหม่',
      signOutAll: 'ออกจากระบบทุกเครื่อง',
      viewAs: 'ดูแบบคนนี้',
    },
    viewAs: {
      title: 'ดูแบบ {{name}}',
      body: 'เปิดแอพในมุมของ {{name}} เห็นแอพ เมนู และรายการเท่าที่เขาเห็น ดูได้อย่างเดียว บันทึกหรือเปลี่ยนอะไรไม่ได้ ไม่เกิน {{minutes}} นาที',
      notice: '{{name}} เห็นในประวัติการเข้าสู่ระบบของตัวเองว่าคุณดูแบบเขาเมื่อไร',
      start: 'เริ่มดู',
    },
  },
  role: {
    title: 'บทบาท',
    plural: 'บทบาทและสิทธิ์',
    fields: {
      key: 'รหัสบทบาท',
      name: 'ชื่อบทบาท',
      description: 'คำอธิบาย',
      permissions: 'สิทธิ์',
      userCount: 'ผู้ใช้',
      grantableBy: 'ใครให้บทบาทนี้ได้',
    },
    fromCode: 'บทบาทและสิทธิ์กำหนดไว้ในระบบ แก้ในแอพไม่ได้ ถ้าต้องการเปลี่ยนให้แจ้งทีมพัฒนา',
    people: '{{count}} คน',
    givenBySuperAdmin: 'เฉพาะผู้ดูแลระบบสูงสุด',
    grantableByHint: 'ให้ได้ทางลิงก์เชิญ การอนุมัติคำขอ และหน้าผู้ใช้ หัวหน้าสาขาให้ได้เฉพาะคนในสาขาตัวเอง',
    rights: {
      title: 'ทำอะไรได้บ้าง',
      everything: 'ทำได้ทุกอย่างในทุกแอพ',
      everywhere: 'ทุกแอพ',
      wholeApp: 'ทำได้ทุกอย่างในส่วนนี้',
      wholeResource: 'ทำได้ทุกอย่าง',
      none: 'บทบาทนี้ไม่มีสิทธิ์ใดเพิ่มจากที่ทุกคนได้',
      branch: 'สาขาตัวเอง',
      own: 'ของตัวเอง',
      branchHint: 'เฉพาะรายการของสาขาประจำ และรายการของตัวเอง',
      ownHint: 'เฉพาะรายการที่เป็นของตัวเอง เช่น งานที่ตัวเองขับ เงินในมือตัวเอง',
    },
    holders: { title: 'ผู้ใช้ที่มีบทบาทนี้', none: 'ยังไม่มีใครมีบทบาทนี้', all: 'ดูทั้งหมดในหน้าผู้ใช้' },
  },
  auditLog: {
    title: 'ประวัติการใช้งาน',
    plural: 'ประวัติการใช้งาน',
    fields: {
      at: 'เวลา',
      userName: 'ผู้ใช้',
      via: 'ผ่านผู้ช่วย',
      action: 'การกระทำ',
      subject: 'ข้อมูล',
      recordId: 'รหัสรายการ',
      summary: 'รายละเอียด',
    },
    options: {
      action: {
        create: 'สร้าง',
        update: 'แก้ไข',
        delete: 'ลบ',
        submit: 'เสนอ',
        cancel: 'ยกเลิก',
        import: 'นำเข้า',
        login: 'เข้าสู่ระบบ',
        print: 'พิมพ์',
        viewAs: 'ดูแบบผู้ใช้',
      },
    },
  },
  actions: {
    read: 'ดู',
    create: 'สร้าง',
    update: 'แก้ไข',
    delete: 'ลบ',
    import: 'นำเข้า',
    export: 'ส่งออก',
    print: 'พิมพ์',
    assign: 'จ่ายงาน',
    submit: 'เสนอ',
    cancel: 'ยกเลิก',
    amend: 'แก้ไขฉบับใหม่',
    onBehalf: 'รับเงินแทนสาขา',
    receive: 'ยืนยันรับเงิน',
    recordFor: 'บันทึกแทนคนไม่มีมือถือ',
    record: 'กรอกตาราง',
    approveVariance: 'อนุมัติยอดขาด/เกิน',
    verify: 'ตรวจสลิปฝากเงิน',
    issue: 'ให้ / เติมเงินสดย่อย',
    review: 'ตรวจรายจ่าย',
    approve: 'อนุมัติ',
    revoke: 'ยกเลิกลิงก์',
    reset: 'ลิงก์ตั้งรหัสผ่านใหม่',
    viewAs: 'ดูแอพแบบผู้ใช้คนอื่น',
    migrate: 'ย้ายข้อมูลจาก Business Zero',
    rotateCode: 'เปลี่ยนรหัสเข้าร่วม',
    clockFor: 'ลงเวลาแทนคนไม่มีมือถือ',
    scan: 'ขึ้น-ลงของ ทำใบคุมรถ',
    cost: 'ตั้งค่าขนส่ง',
    deliver: 'บันทึกผลส่ง',
    collect: 'เก็บเงินปลายทาง',
    handover: 'ส่งมอบให้ผู้รับที่สาขา',
    undeliver: 'ยกเลิกส่งมอบที่บันทึกผิด',
    return: 'ตีกลับผู้ส่ง',
    invite: 'เชิญเข้าใช้งาน',
    offboard: 'บันทึกพ้นสภาพ',
    merge: 'รวมรายการซ้ำ',
    pay: 'จ่ายเงิน',
    calculate: 'คำนวณ',
    reopen: 'เปิดกลับมาแก้',
  },
} as const

export const en = {
  app: { name: 'Admin', description: 'Users, roles, permissions and the activity log' },
  nav: { users: 'Users', roles: 'Roles & permissions', permissions: 'Permissions by app', audit: 'Activity log', migrate: 'Move in' },
  migrate: {
    title: 'Move in from Business Zero',
    hint: 'Read the records and balances from Business Zero, map values and edit rows first, then import step by step in order',
    source: {
      title: 'Source',
      notConnected: 'Business Zero is not connected',
      notConnectedHint: "Set the API's BUSINESS_ZERO_DATABASE_URL to a database account that may only read first (docs/deploy.md)",
      company: 'Company in Business Zero',
      year: 'Year brought forward',
      pulled: 'Read {{at}} by {{by}}',
      pull: 'Read the latest',
      pulledDone: 'Read from Business Zero',
      keeps: 'Read again any time: mapped values and edited rows stay',
      none: 'Nothing read yet: pick the company and year, then read',
    },
    steps: {
      title: 'Import steps',
      hint: 'Import in order: later steps name what earlier ones hold',
      rows: '{{count}} rows',
      fix: '{{count}} to fix',
      check: '{{count}} to check',
      edited: '{{count}} edited',
      skipped: '{{count}} left out',
      linked: '{{count}} use existing',
      import: 'Import',
      importAgain: 'Import again',
      imported: 'Imported {{at}}',
      counts: '{{created}} new · {{updated}} updated',
      failed: '{{count}} rows failed',
      done: 'Imported: {{created}} new, {{updated}} updated',
      doneFailed: 'Imported: {{created}} new, {{updated}} updated, {{failed}} rows failed',
      openingFailed: 'Balances not saved: {{failed}} rows failed, and every row must pass',
      ready: '{{count}} rows will go in',
      held: '{{count}} rows to fix stay out until fixed, or saved as looked at',
      importAll: 'Import all',
      importAllTitle: 'Import all the records',
      importAllBody:
        'Imports steps 1–{{last}} in order and stops at the first with rows to fix or refused, as later steps name what it holds. Balances brought forward are not included: import them step by step after the last pay run in Business Zero',
      importingAll: 'Importing {{n}}/{{total}}: {{title}}',
      importAllDone: 'All {{count}} record steps imported: the balances brought forward are left',
      importAllStopped: 'Stopped at {{title}}: {{fix}} rows to fix, {{failed}} refused. Open it, fix them, then import all again',
      empty: 'No rows',
    },
    maps: {
      title: 'Map values',
      hint: "What Business Zero's values are in Thananan OS: guessed by the rules at first; a change applies to every step at once",
      value: 'In Business Zero',
      count: 'Used',
      target: 'In Thananan OS',
      none: 'None',
      guessed: 'Guessed',
      reset: 'Use the guess',
      names: {
        bank: 'Bank',
        partyType: 'Partner type',
        employeeStatus: 'Employee status',
        payBasis: 'Pay basis',
        payMethod: 'Pay method',
        leaveType: 'Kind of leave',
        vehicleType: 'Vehicle type',
        vehicleStatus: 'Vehicle status',
      },
    },
    totals: { title: 'Figures to compare', hint: 'Once everything is imported, these should match' },
    left: { title: 'What stays behind' },
    clear: {
      action: 'Clear what was read',
      title: 'Clear what was read from Business Zero?',
      body: "What was read, mapped values, edited rows and import results go; what was imported stays. Do it once the move is done: it holds everyone's pay and bank accounts",
      done: 'Cleared what was read',
    },
    step: {
      all: 'All',
      fix: 'To fix',
      check: 'To check',
      edited: 'Edited',
      skipped: 'Left out',
      linked: 'Use existing',
      failed: 'Import failed',
      done: 'Imported',
      notes: 'Notes',
      empty: 'No rows match this filter',
    },
    row: {
      title: 'Edit row',
      skip: 'Leave this row out',
      link: 'Use one that exists instead',
      linkHint: 'This row is not created; rows that name it point at the one picked',
      linkNone: 'Create from this row',
      reset: "Back to Business Zero's",
      savedHint: "Saving marks the row as looked at: its notes go, while each field's rules are still checked every time",
      failure: 'The last import failed',
      saved: 'Row saved',
    },
  },
  access: {
    title: 'Who can do what',
    everything: '{{roles}}: everything in every app, so not repeated on each row',
    only: 'Only {{roles}}',
    everyone: 'Everyone',
    users: 'Users with access',
    more: '{{count}} more',
    search: 'Find a document type',
    allApps: 'All apps',
    none: 'No document type found',
    hint: 'Pick a document type to see what each role can do with it, and who holds that role',
    nobody: 'No role reaches it',
  },
  user: {
    title: 'User',
    plural: 'Users',
    create: 'Add user',
    fields: {
      name: 'Name',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      roleIds: 'Roles',
      branchId: 'Home branch',
      active: 'Active',
      password: 'Password',
      lastLoginAt: 'Last sign-in',
    },
    sections: { main: 'User', access: 'Access' },
    passwordHint: 'At least 8 characters. Leave empty to keep the current one.',
    actions: { resetPassword: 'Set new password', signOutAll: 'Sign out everywhere', viewAs: 'View as this person' },
    viewAs: {
      title: 'View as {{name}}',
      body: 'Opens the apps as {{name}} sees them: their apps, menus and records. You can only look, not save or change anything, for {{minutes}} minutes at most.',
      notice: '{{name}} sees in their own sign-in history when you viewed as them.',
      start: 'Start viewing',
    },
  },
  role: {
    title: 'Role',
    plural: 'Roles & permissions',
    fields: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      permissions: 'Permissions',
      userCount: 'Users',
      grantableBy: 'Who can give this role',
    },
    fromCode: 'Roles and permissions are set in the system and cannot be edited in the apps. Ask the development team to change one',
    people: '{{count}} people',
    givenBySuperAdmin: 'Super admins only',
    grantableByHint: 'Given through invite links, approving requests and the user page; branch leads only within their branch',
    rights: {
      title: 'What it can do',
      everything: 'Everything in every app',
      everywhere: 'Every app',
      wholeApp: 'Everything here',
      wholeResource: 'Everything',
      none: 'Nothing beyond what everyone has',
      branch: 'Own branch',
      own: 'Own',
      branchHint: 'Only records of their home branch, and their own',
      ownHint: 'Only their own records, such as the jobs they drive or the cash in their hands',
    },
    holders: { title: 'Users with this role', none: 'Nobody has this role yet', all: 'See all on the users page' },
  },
  auditLog: {
    title: 'Activity log',
    plural: 'Activity log',
    fields: { at: 'Time', userName: 'User', via: 'Through', action: 'Action', subject: 'Data', recordId: 'Record', summary: 'Details' },
    options: {
      action: {
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        submit: 'Submit',
        cancel: 'Cancel',
        import: 'Import',
        login: 'Sign in',
        print: 'Print',
        viewAs: 'View as',
      },
    },
  },
  actions: {
    read: 'View',
    create: 'Create',
    update: 'Edit',
    delete: 'Delete',
    import: 'Import',
    export: 'Export',
    print: 'Print',
    assign: 'Assign',
    submit: 'Submit',
    cancel: 'Cancel',
    amend: 'Amend',
    onBehalf: 'Take payment for a branch',
    receive: 'Confirm received',
    recordFor: 'Record for someone without a phone',
    record: 'Fill in the sheet',
    approveVariance: 'Approve shortage/surplus',
    verify: 'Verify deposit slip',
    issue: 'Issue petty cash',
    review: 'Review expense',
    approve: 'Approve',
    revoke: 'Revoke link',
    reset: 'Password reset link',
    viewAs: 'View the apps as someone else',
    migrate: 'Move in from Business Zero',
    rotateCode: 'New join code',
    clockFor: 'Clock for someone without a phone',
    scan: 'Load, unload and make manifests',
    cost: 'Write transport costs',
    deliver: 'Record deliveries',
    collect: 'Collect at the door',
    handover: 'Hand over at the branch',
    undeliver: 'Undo a handover recorded by mistake',
    return: 'Send back to the sender',
    invite: 'Invite',
    offboard: 'Record leaving',
    merge: 'Merge duplicates',
    pay: 'Pay',
    calculate: 'Calculate',
    reopen: 'Reopen',
  },
} as const
